import { Analytics } from './analytics';

let icon = $('[icon-menu-item-url-tracking]');

icon.click((e) => {
    let url = $(e.currentTarget).attr('href');
    let label = $(e.currentTarget).find('[icon-menu-item-label-tracking]').text();
    
    Analytics.sendEvent('Homepage - Stackholder icons', label, url)
});